{
    "AuthoriseButton_Title": "Autorizzare",
    "PreAuthoriseButton_Title": "Pre-autorizzazione",
    "Authentication_PreAuthorisation_Successful": "Pre-Autorizzato",
    "Authentication_Successful": "Autorizzazione concessa",
    "Authentication_Failed": "Il processo di autorizzazione è fallito.",
    "Authentication_Authenticated": "Questo server di telefonia è già stato autorizzato.",
    "Authentication_Status_Title": "Stato dell'autorizzazione",
    "Authentication_Status_Warning": "C'è un avviso per questa autorizzazione, si può provare a ri-autorizzare per risolvere il problema.",
    "Authentication_Status_Warning_Range_30100_30199": "Autorizzazione riuscita, ma è stato rilevato un problema di comunicazione con MS Teams. Contattare l'assistenza clienti Akixi.",
    "Authentication_Status_Warning_Range_30200_30299": "Autorizzazione riuscita, ma è stato rilevato un problema di sincronizzazione con MS Teams. Contattare l'assistenza clienti Akixi.",
    "NAME": "OAuthButton"
}